import SEO from "../components/SEO";
import { Reveal, Chapter, MaskedLine } from "../components/Reveal";

const CONTENT = {
  "privacy-policy": {
    title: "Privacy Policy",
    description: "How Grotech Web collects, uses and protects your information.",
    sections: [
      { h: "What we collect", p: "When you submit an enquiry form, we receive the details you provide — name, business name, phone number, city and requirement — solely to respond to your enquiry. We use analytics (Google Analytics 4) to understand how the website is used; this data is aggregated and does not identify you personally." },
      { h: "How we use it", p: "Your contact details are used only to discuss your website requirements. We do not sell, rent or share your personal information with third parties for marketing." },
      { h: "WhatsApp communication", p: "If you contact us via WhatsApp, that conversation is governed by WhatsApp's own privacy practices in addition to this policy." },
      { h: "Your choices", p: "You can ask us to delete your enquiry details at any time by messaging us on WhatsApp at +91 98217 71460." },
      { h: "Contact", p: "Questions about this policy: WhatsApp +91 98217 71460." },
    ],
  },
  terms: {
    title: "Terms of Service",
    description: "The terms governing use of the Grotech Web website and services.",
    sections: [
      { h: "Services", p: "Grotech Web provides website development, web design, SEO, Shopify development, AI chatbot development and business automation services. Specific scope, timeline and pricing for any project are agreed individually before work begins." },
      { h: "Website content", p: "Content on this website is for general information. Portfolio case studies describe real project approaches; sample items are clearly labeled as such." },
      { h: "No guaranteed rankings", p: "Search engine rankings depend on many factors outside anyone's control. We commit to strong technical SEO foundations and consistent quality work — we do not guarantee specific ranking positions." },
      { h: "Intellectual property", p: "Completed website deliverables become the client's property upon full payment. You always own your domain, content and website files." },
      { h: "Contact", p: "Questions about these terms: WhatsApp +91 98217 71460." },
    ],
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page];
  return (
    <main className="pt-36 pb-24 lg:pt-44">
      <SEO
        title={`${c.title} | Grotech Web`}
        description={c.description}
        path={`/${page}`}
      />
      <article className="mx-auto max-w-3xl px-4 sm:px-8" data-testid={`${page}-page`}>
        <Chapter index="—" label="Legal" />
        <h1 className="mt-8 font-display text-4xl font-black tracking-tight sm:text-5xl">
          <MaskedLine>{c.title}</MaskedLine>
        </h1>
        {c.sections.map((s, i) => (
          <Reveal key={s.h} delay={i * 0.05}>
            <h2 className="mt-10 font-display text-xl font-bold tracking-tight">{s.h}</h2>
            <p className="mt-3 text-sm leading-relaxed text-white/55">{s.p}</p>
          </Reveal>
        ))}
      </article>
    </main>
  );
}
